<template>
  <div class="login-page">
    <el-form class="login-container" :model="form" :rules="rules" ref="domain">

      <div class="lang-switch">
        <el-select v-model="info.emo" @change="changeSelection" size="small">
          <el-option v-for="item in emoList" :key="item.Id" :value="item.text">
            <img :src="item.src" style="width:16px;height:16px;vertical-align:text-bottom;margin-right:4px;">
            {{ item.text }}
          </el-option>
        </el-select>
      </div>

      <div class="login-header">
        <h2 class="login_title">{{ $t('msg.Login') }}</h2>
      </div>

      <el-form-item prop="username">
        <el-input
          v-model="form.username"
          :placeholder="$t('msg.User_Name1')"
          prefix-icon="el-icon-user"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="form.password"
          :placeholder="$t('msg.Password1')"
          prefix-icon="el-icon-lock"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="login-btn" @click="login" type="primary">{{ $t('msg.Login') }}</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import { Login } from '../api'
import zh from '../assets/zh.png';
import us from '../assets/us.png';

var LxStr = function(str){
  if(str){
    var arr = str.split('');
    var flag = true;
    for (var i = 1; i < arr.length-1; i++) {
      var firstIndex = arr[i-1].charCodeAt();
      var secondIndex = arr[i].charCodeAt();
      var thirdIndex = arr[i+1].charCodeAt();
      // thirdIndex - secondIndex == 1;
      // secondIndex - firstIndex==1;
      if((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
        flag =  false;
      }
    }
    return flag;
  }
}
export default {
  name: "Login",
  data() {
    return {
      info: {emo: "简体中文"},
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {min: 7, max: 16, message: this.$t('msg.The_length_is_716_characters'), trigger: 'blur'},
          {validator: (rule, value, callback) => {
              // const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/ 带有下划线_
              const reg = /^[A-Za-z0-9]+$/
              if(!reg.test(value)){
                callback(new Error(this.$t('msg.Username_format_hint')))
              }else{
                callback()
              }
            },
            trigger: "blur"
          }
        ],
        password: [
          {required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur'},
          {min: 6, max: 16, message: this.$t('msg.The_length_is_616_characters'), trigger: 'blur'},
          // {
          //   validator: (rule, value, callback) => {
          //     var re2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d/!/-/_]{6,}$/
          //     const rsCheck2 = re2.test(value);
          //     if (value==="******"){
          //       callback();
          //     }
          //     else if (!rsCheck2) {
          //       callback(new Error('密码最少6位,必须是数字和字母组合.其中至少有一位字母大写和一位字母小写,密码中可以有! - _ 这三个符号.'));
          //     }else if(!LxStr(value)){
          //       callback(new Error('不能输入3位以上连续的数字和字母'))
          //     }
          //     callback();
          //   },
          //   trigger: "blur"
          // }
        ],
      },
      // label：图片路径 value：方向指向
      emoList:[
        {Id: `1`, src: zh, text: `简体中文`, value: 'zh' },
        {Id: `2`, src: us, text: `English`, value: 'us' } ],  // 定义下拉框数据

    }
  },
  methods: {
    login() {
      var val = true
      var from = 'domain'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      //登录
      if (val){
        Login(this.form).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            localStorage.setItem('token', data.data.params.token)
            localStorage.setItem('username', data.data.params.username)
            localStorage.setItem('proxy_id', data.data.params.proxy_id)
            var userInfo = {}
            userInfo["level"] = data.data.params.level
            userInfo["coins"] = data.data.params.coins
            if (data.data.params.is_sub){
              userInfo["is_sub"] = data.data.params.is_sub
              userInfo["sub_proxy_id"] = data.data.params.sub_proxy_id
              userInfo["permissions_type"] = data.data.params.permissions_type
              userInfo["up_username"] = data.data.params.up_username
            }
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.$router.push({name: 'accountList'})
          }
          else {
            var msg = "登录失败"
            if (data.data.params.msg){
              msg = data.data.params.msg
            }
            this.$message.error(msg);
          }
        })
      }
    },
    //关系方向下拉框改变事件
    changeSelection (val) {
      var lang = val === 'English' ? 'US' : 'CN'
      this.$i18n.locale = lang
      localStorage.setItem("lang", lang)
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#51b4af')
  },
  beforeDestroy() {
    // document.querySelector('body').setAttribute('style', '')
  },
  mounted() {
    var lang = localStorage.getItem('lang') || 'CN'
    this.$i18n.locale = lang
    localStorage.setItem("lang", lang)
    this.info.emo = lang === 'CN' ? '简体中文' : 'English'
  }
}
</script>

<style lang="less" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a2a3a 0%, #0f3460 50%, #16213e 100%);
}


.login-container {
  position: relative;
  width: 420px;
  padding: 48px 40px 36px;
  margin-top: -20vh;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  box-sizing: border-box;

  .lang-switch {
    position: absolute;
    top: 14px;
    right: 16px;

    /deep/ .el-input__inner {
      width: 110px;
      border-radius: 6px;
      font-size: 12px;
      height: 30px;
      line-height: 30px;
      padding-right: 24px;
    }

    /deep/ .el-input__suffix {
      line-height: 30px;
    }
  }

  .login-header {
    text-align: center;
    margin-bottom: 32px;

    .login_title {
      font-size: 24px;
      font-weight: 600;
      color: #1a2a3a;
      margin: 0;
      letter-spacing: 1px;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 20px;

    .el-input__inner {
      height: 46px;
      border-radius: 8px;
      font-size: 14px;
      border-color: #dcdfe6;
      transition: border-color 0.2s;

      &:focus {
        border-color: #0f3460;
      }
    }

    .el-input__prefix {
      color: #909399;
    }
  }

  .login-btn {
    width: 100%;
    height: 46px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 8px;
    background: linear-gradient(90deg, #0f3460, #1a6aa0);
    border: none;
    letter-spacing: 1px;
    margin-top: 8px;
    transition: opacity 0.2s, transform 0.1s;

    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

@media screen and (max-width: 500px) {
  .login-container {
    width: 90%;
    padding: 36px 24px 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue